module.exports = __webpack_public_path__ + "static/media/depression.1a7698d2.jpg";